import React from "react";
import { useTranslation } from "react-i18next";
import { PrivacyHe } from "../../components/Privacy/PrivacyHe";
import { PrivacyEn } from "../../components/Privacy/PrivacyEn";

const normalize = (lang?: string) => {
  if (!lang) return null;

  const v = lang.toLowerCase();

  const mapping: Record<string, "en" | "he"> = {
    en: "en",
    he: "he",
  };

  return mapping[v] ?? null;
};

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  const lang = t("graphql.languageCode");
  const resolved = normalize(lang);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!resolved) {
    return <PrivacyEn />;
  }

  return resolved === "en" ? <PrivacyEn /> : <PrivacyHe />;
};

export default PrivacyPage;
